import React from 'react';
import { m } from 'framer-motion';
import { SectionTag } from '../ui/SectionTag';
import { images, highlights } from '../../data/insideLook';
export function InsideLook() {
  return <section className="bg-white py-14 sm:py-20" data-id="element-110" data-mp="1t4ea3riy9j5a">
      <div className="mx-auto max-w-2xl px-4 text-center sm:px-6" data-id="element-111" data-mp="1t44g7susarub">
        <SectionTag icon="📸" tone="primary" data-id="element-112" data-mp="1o5b4o5z25aws">
          Material real
        </SectionTag>
        <h2 className="mt-5 font-heading text-3xl font-bold leading-tight text-primary sm:text-4xl" data-id="element-113" data-mp="10fgvbydy64ha">
          Un vistazo al interior de tu nueva biblioteca
        </h2>
        <p className="mt-4 text-base leading-relaxed text-ink sm:text-lg" data-id="element-114" data-mp="1ae6cfoy0rkwh">
          Fichas técnicas reales, diseñadas para abrir, leer y enseñar sin dudar.
        </p>
      </div>

      <div className="mx-auto mt-12 max-w-5xl px-4 sm:px-6" data-id="element-115" data-mp="15h657apfoc3s">
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 sm:gap-6 md:grid-cols-3" data-id="element-116" data-mp="2lsa60u0p3710">
          {images.map((image, i) => <m.div key={image.src} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: i % 3 * 0.08
        }} className="flex items-center justify-center overflow-hidden rounded-2xl bg-paper p-3 shadow-card-light" data-id="element-117" data-mp="2gtyw6jaegwis" data-mpi={i}>
              <img src={image.src} alt={image.alt} loading="lazy" decoding="async" className="aspect-[3/4] w-full max-w-xs object-contain sm:max-w-none" data-id="element-118" data-mp="14cx9mnrp0a9s" />
            </m.div>)}
        </div>
      </div>

      <div className="mx-auto mt-14 max-w-3xl px-4 sm:px-6" data-id="element-119" data-mp="gmbgs3q9ewkd">
        <m.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.45
      }} className="rounded-3xl bg-paper p-8 sm:p-12" data-id="element-120" data-mp="leur8rtnhbky">
          <h3 className="font-heading text-2xl font-bold leading-snug text-primary sm:text-3xl" data-id="element-121" data-mp="3p1v64rnt7uu5">
            No es solo información, es una herramienta de precisión.
          </h3>
          <p className="mt-4 text-sm leading-relaxed text-ink sm:text-base" data-id="element-122" data-mp="r9bf4tmabokm">
            Lo que ves arriba es exactamente lo que recibirás: fichas técnicas de alta definición diseñadas
            para ser consultadas en el fragor de la clase.
          </p>
          <p className="mt-3 text-sm leading-relaxed text-ink sm:text-base" data-id="element-123" data-mp="da3jgapbyyl6">
            Olvídate de los manuales densos con párrafos interminables. Aquí encontrarás:
          </p>

          <div className="mt-8 grid gap-5 sm:grid-cols-2" data-id="element-124" data-mp="mb1mapo19026">
            {highlights.map(item => <div key={item.title} className="flex items-start gap-3" data-id="element-125" data-mp="i9g3knothrk2">
                <div className="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-lg bg-accent/10" data-id="element-126" data-mp="i851qtexmtvl">
                  <item.icon size={18} className="text-accent" data-id="element-127" data-mp="1xs1d1guqf6u3" />
                </div>
                <div data-id="element-128" data-mp="1tqo6f4jtezm4">
                  <p className="font-heading text-sm font-semibold text-primary" data-id="element-129" data-mp="218495ihpke36">{item.title}</p>
                  <p className="mt-1 text-sm leading-relaxed text-ink/80" data-id="element-130" data-mp="2677df0pv6ga3">{item.text}</p>
                </div>
              </div>)}
          </div>
        </m.div>
      </div>
    </section>;
}